import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FilmSliderProject from './FilmSliderProject';

import * as experimentsActions from '../../actions/actionsExperiments';

import dataContent from '../../data/content.json';

import 'rc-slider/assets/index.css';

class FilmSlider extends Component {
  render() {
    const { match } = this.props;
    return (
      <div className='inner-container'>
        <div className="selector">
          {dataContent['film-slider'].projects.map((project, i) => <Link key={i} to={`${match.url}/${project.id}`}>{project.name}</Link>)}
        </div>

        <Route path={`/experiments/filmslider/:projectId`} component={FilmSliderProject} />
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    experiments: state.experiments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(experimentsActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilmSlider);



// WEBPACK FOOTER //
// ./src/components/experiments/FilmSlider.js